export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()

  if (config.public.instance === 'demo') {
    return
  }

  useHead({
    script: [
      {
        src: '/helpscout.js',
        body: true,
        async: true,
      },
    ],
  })
})
